import Vue from "vue";
import Router from "vue-router";

//pages for public
import Registration from "@/components/registration/Registration"
import RegistrationSuccess from "@/components/registration/RegistrationSuccess"
import RegistrationSummary from "@/components/registration/RegistrationSummary"
import Activation from "@/components/registration/Activation"
import ResetPassword from "@/components/home/listData/ResetPassword"

//pages for the portal
import ContractAgreement from "@/components/portal/ContractAgreement"
import PortalHome from "@/components/portal/Home"
import Version from "@/components/home/Version"
import PortalUserAccount from "@/components/portal/userAccount/UserAccount"
import PortalCatalog from "@/components/portal/Catalog"
import PortalOrder from "@/components/portal/Order/Order"
import PortalOrderConfirmation from "@/components/portal/Order/OrderConfirmation"
import PortalExamConfirmation from "@/components/portal/Order/ExamConfirmation"
import PortalOrderTracking from "@/components/portal/OrderTracking/OrderTracking"
import PortalOrderSubmit from "@/components/portal/Order/OrderSubmit/OrderSubmit"
import AnnualForcasting from "@/components/portal/AnnualForcasting"
// import CovidReliefRegistration from "@/components/portal/CovidReliefRegistration"

//pages for Order
import OrderSummary from "@/components/portal/Order/OrderSummary"


//pages for Exam
import ExamSummary from "@/components/portal/Order/ExamSummary"

//pages for Frame
import FramesCenter from "@/components/portal/frameResources/FramesCenter"
import FrameOrderSuccess from "@/components/portal/frameResources/FrameOrderSuccess"

//Portal Pages
import Resource from "@/components/portal/Resource"
import Help from "@/components/portal/Help"
import Demo from "@/components/portal/Demo"

//error page
import ErrorPage from "@/components/shared/ErrorPage"
Vue.use(Router);

const referralLogos = {
    teamvision: "https://evfportal.s3.amazonaws.com/General+Image+Bucket/LOGOTAGLINE_white.png",
    openingeyes: "https://openingeyes.png",
    // Add more mappings here as needed
};

const defaultLogo = '/static/assets/img/blank.png';

const setReferralData = (to) => {
    const referralCode = to.params.referralCode || to.query.referralcode;
    let logoUrl = defaultLogo; // Default to blank image

    if (referralCode) {
        const normalizedCode = referralCode.toLowerCase();
        sessionStorage.setItem("referralCode", normalizedCode);
        logoUrl = referralLogos[normalizedCode] || defaultLogo;
    }

    sessionStorage.setItem("referralLogo", logoUrl);
};


const guard = function(to, from, next) {
    axios.get('/Auth/TryConnect', {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
    .then(function (response) {
        if(response.data.isSuccess){
            next();
        }else{
            removeLocalStorageItems();
        }
    })
    .catch(function (error) {
        removeLocalStorageItems();
    });
};

var removeLocalStorageItems = function() {
    localStorage.removeItem('accountType');
    localStorage.removeItem('host');
    localStorage.removeItem('id');
    sessionStorage.removeItem('referralCode');
    localStorage.removeItem('referrer');
    localStorage.removeItem('token');
    localStorage.removeItem('watchword');
    var fromName = localStorage.getItem("fromName");
    if(fromName =="ToMasterAccount")
    {
        localStorage.removeItem('fromName');
        window.location.href="/MasterAccount";
    }
    else
    {
        window.location.href="/";
    }
    localStorage.removeItem("ClinicEventList")
};

var setItems = function(to, from, next)
{
    localStorage.setItem("nextURL",to.path.toUpperCase().replace('/MASTERACCOUNT',''));
    localStorage.setItem("fromName","ToMasterAccount");
    guard(to, from, next);
}

export default new Router({
    mode: "history",
    routes: [
        {
            path: "/Portal/Order/MasterAccount",
            name:'OrdersMasterAccount',
            component: () => import("@/components/home/MasterAccount"),
            beforeEnter: (to, from, next) => {
                if(localStorage.getItem('accountType') == 'master'){
                    next({ path: "/Portal/Order"});
                } else {
                    setItems(to, from, next);
                }
            }
        },
        {
            path: "/Portal/Order/:code?/:EditOrReuse?/MasterAccount",
            name:'OrderMasterAccount',
            component: () => import("@/components/home/MasterAccount"),
            beforeEnter: (to, from, next) => {
                if(localStorage.getItem('accountType') == 'master'){
                    next({ path: `/Portal/Order/${to.params.code}/${to.params.EditOrReuse}`});
                } else {
                    setItems(to, from, next);
                }

            }
        },
        {
            path: "/Portal/OrderConfirmation/:code/:isSummaryOnly/MasterAccount",
            name:'OrderConfirmationMasterAccount',
            component: () => import("@/components/home/MasterAccount"),
            beforeEnter: (to, from, next) => {
                if(localStorage.getItem('accountType') == 'master'){
                    next({ path: `/Portal/OrderConfirmation/${to.params.code}/${to.params.isSummaryOnly}`});
                } else {
                    setItems(to, from, next);
                }
            }
        },
        {
            path: "/Portal/UserAccount/MasterAccount",
            name:'UserAccountMasterAccount',
            component: () => import("@/components/home/MasterAccount"),
            beforeEnter: (to, from, next) => {
                if(localStorage.getItem('accountType') == 'master'){
                    next({ path: `/Portal/UserAccount`});
                } else {
                    setItems(to, from, next);
                }
            }
        },
        {
            path: "/Portal/Home/MasterAccount",
            name:'HomeMasterAccount',
            component: () => import("@/components/home/MasterAccount"),
            beforeEnter: (to, from, next) => {
                setItems(to, from, next);
            }
        },
        {
            path: "/Portal/OrderTracking/MasterAccount",
            name:'OrderTrackingMasterAccount',
            component: () => import("@/components/home/MasterAccount"),
            beforeEnter: (to, from, next) => {
                if(localStorage.getItem('accountType') == 'master'){
                    next({ path: `/Portal/OrderTracking`});
                } else {
                    setItems(to, from, next);
                }
            }
        },
        {
            path: "/Portal/Frames/MasterAccount",
            name:'FramesMasterAccount',
            component: () => import("@/components/home/MasterAccount"),
            beforeEnter: (to, from, next) => {
                if(localStorage.getItem('accountType') == 'master'){
                    next({ path: `/Portal/Frames`});
                } else {
                    setItems(to, from, next);
                }
            }
        },
        {
            path: "/Portal/Resources/MasterAccount",
            name:'ResourcesMasterAccount',
            component: () => import("@/components/home/MasterAccount"),
            beforeEnter: (to, from, next) => {
                if(localStorage.getItem('accountType') == 'master'){
                    next({ path: `/Portal/Resources`});
                } else {
                    setItems(to, from, next);
                }
            }
        },
        {
            path: "/Portal/Help/MasterAccount",
            name:'HelpMasterAccount',
            component: () => import("@/components/home/MasterAccount"),
            beforeEnter: (to, from, next) => {
                if(localStorage.getItem('accountType') == 'master'){
                    next({ path: `/Portal/Help`});
                } else {
                    setItems(to, from, next);
                }
            }
        },
        {
            path: "/Portal/ExamConfirmation/:code/:isSummaryOnly/MasterAccount",
            name:'ExamConfirmationMasterAccount',
            component: () => import("@/components/home/MasterAccount"),
            beforeEnter: (to, from, next) => {
                if(localStorage.getItem('accountType') == 'master'){
                    next({ path: `/Portal/ExamConfirmation/${to.params.code}/${to.params.isSummaryOnly}`});
                } else {
                    setItems(to, from, next);
                }
            }
        },
        {
            path: "/",
            name: "Home",
            component: () => import("@/components/home/Home"),
        },
        {
            path: "/cltl-day",
            name: "CLTLDay",
            component: () => import("@/components/home/CLTLDay"),
        },
        {
            path: "/Referral/:referralCode?",
            name: "Referral",
            component: () => import("@/components/home/Home"),
            beforeEnter: (to, from, next) => {
                setReferralData(to); // Capture referral code here
                next();
            }
        },
        {
            path: "/Error",
            name: "Error",
            component: ErrorPage
        },
        {
            path:"/MasterAccount",
            name: "MasterAccount",
            component: () => import("@/components/home/MasterAccount"),
        },
        {
            path: "/Registration/:type?",
            name: "Registration",
            component: () => import("@/components/registration/Registration"),
        },
        
        // {
        //     path: "/RegistrationSuccess",
        //     name: "RegistrationSuccess",
        //     component: () => import("@/components/registration/RegistrationSuccess")
        // },
      {
        path: "/RegistrationSuccess",
        name: "RegistrationSuccess",
        component: () => import("@/components/home/Home"),
      },
        // {
        //     path: "/CovidReliefRegistration",
        //     name: "CovidReliefRegistration",
        //     component: CovidReliefRegistration
        // },
        {
            path: "/RegistrationSummary:accountId?",
            name: "RegistrationSummary",
            component: () => import("@/components/registration/RegistrationSummary")
        },
        {
            path: "/Activation/:code",
            name: "Activation",
            component: () => import("@/components/registration/Activation")
        },
        {
            path: "/ResetPassword/:code",
            name: "ResetPassword",
            component: () => import("@/components/home/listData/ResetPassword")
        },
        {
            path: "/Portal/ContractAgreement",
            name:"ContractAgreement",
            component: ContractAgreement,
        },
        {
            path: "/Portal/AnnualForecasting",
            name:"AnnualForecasting",
            component: () => import("@/components/portal/AnnualForcasting")
        },
        {
            path: "/Portal/Home/",
            name:"PortalHome",
            component: PortalHome,
            beforeEnter: (to, from, next) => {
              guard(to, from, next);
            }
        },
        {
            path: "/Version/",
            name:"Version",
            component: Version,
        },
        {
            path: "/Portal/UserAccount",
            name: "UserAccount",
            component: PortalUserAccount,
            beforeEnter: (to, from, next) => {
                if(from.path == "/" && from.name !="Home")
                {
                    localStorage.setItem("nextURL",to.path);
                }
                guard(to, from, next);
            }
        },
        {
            path: "/Portal/Order/:code?/:EditOrReuse?",
            name:'Order',
            component: PortalOrder,
            beforeEnter: (to, from, next) => {
                if(from.path == "/" && from.name !="Home")
                {
                    guard(to, from, next);
                    localStorage.setItem("nextURL",to.path);
                }
               else{
                var toBeConvertedToOrder = (to.params.EditOrReuse === 2) || (to.params.EditOrReuse === 3);

                var isRemakeOrRedo = to.fullPath.split('/')[4] == "1";

                var currentUrl = (window.location.pathname == "/" || window.location.pathname == "/Portal/AnnualForecasting")
                        ? to.path
                        : window.location.pathname;
                var orderId = currentUrl.split('/')[3];
                var orderIdValue = orderId == undefined
                        ? ""
                        : orderId;

                var userIsPlacingNewOrder = to.fullPath == "/Portal/Order" &&
                    (from.name == "OrderConfirmation" || from.name == "OrderSubmit" || from.name == "ExamConfirmation");

                if (orderIdValue != "" && !isRemakeOrRedo){

                    var orderStatus = '';

                    axios.get('/Order/GetOrderStatus/' + orderId + '/',{headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                    .then(function (response) {
                        if(response.data.raw){

                            var originPath = from.name;
                            var destinationPath = to.name;
                            orderStatus = response.data.raw.orderStatus;

                            var userIsEditingAnExamOnlyOrder = (originPath == "ExamConfirmation" && destinationPath == "Order" && orderStatus == "ExamOnly")

                            if (toBeConvertedToOrder || userIsPlacingNewOrder || userIsEditingAnExamOnlyOrder ||
                                    ((orderStatus === 'Pending' || orderStatus === 'PendingError') || (response.data.raw.isMaster && orderStatus === 'PendingApproval'))){
                                guard(to, from, next);
                            }
                            else{
                                window.location.href="/Portal/OrderTracking";
                            }
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                }
                else{
                    guard(to, from, next);
                }
            }
            }
        },
        {
            path: "/Portal/OrderConfirmation/:code/:isSummaryOnly",
            name:'OrderConfirmation',
            component: PortalOrderConfirmation,
            beforeEnter: (to, from, next) => {

               if(from.path == "/" && from.name !="Home")
                {
                    guard(to, from, next);
                    localStorage.setItem("nextURL",to.path);
                }
               else{
                var currentUrl = (window.location.pathname == "/" || window.location.pathname == "/Portal/AnnualForecasting")
                        ? to.path
                        : window.location.pathname;
                var orderId = currentUrl.split('/')[3];
                var isSummaryOnly = currentUrl.split('/')[4];
                var orderIdValue = orderId == undefined
                        ? ""
                        : orderId;

                if (orderIdValue != ""){

                    var orderStatus = '';

                    axios.get('/Order/GetOrderStatus/' + orderId + '/',{headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                    .then(function (response) {
                        if(response.data.raw){

                            orderStatus = response.data.raw.orderStatus;

                            if (orderStatus == "InProcess" || orderStatus == "Shipped" || orderStatus == "Cancelled") {
                                    guard(to, from, next);
                            }
                            else{
                                window.location.href="/Portal/Order/"+orderIdValue+"/"+isSummaryOnly;
                            }
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                }
                else{
                    guard(to, from, next);
                }

                // var oc_param = localStorage.getItem('trackorder-param');
                // var oc_url = localStorage.getItem('url');
                // if(from.name === 'Order' || oc_param === 'fromViewOrder'){
                //     guard(to, from, next);
                // }
                // else{
                //     window.location.href= oc_url;
                // }
            }
            }
        },
        {
            path: "/Portal/ExamConfirmation/:code/:isSummaryOnly",
            name:'ExamConfirmation',
            component: PortalExamConfirmation,
            beforeEnter: (to, from, next) => {
                if(from.path == "/" && from.name !="Home")
                {
                    localStorage.setItem("nextURL",to.path);
                }
                guard(to, from, next);
            }
        },
        {
            path: "/Portal/OrderSubmit/:code/:type",
            name:'OrderSubmit',
            component: PortalOrderSubmit,
            beforeEnter: (to, from, next) => {
                guard(to, from, next);
            }
        },
        {
            path: "/Portal/OrderTracking/",
            name:'OrderTracking',
            component: PortalOrderTracking,
            beforeEnter: (to, from, next) => {
                if(from.path == "/" && from.name !="Home")
                {
                    localStorage.setItem("nextURL",to.path);
                }
                guard(to, from, next);
              }
        },
        {
            path: "/ExamSummary/:orderId?",
            name: "ExamSummary",
            component: ExamSummary
        },
        {
            path: "/OrderSummary/:orderId?",
            name: "OrderSummary",
            component: OrderSummary
        },
        {
            path: "/Portal/Resources",
            name:"Resource",
            component: () => import("@/components/portal/Resource"),
            beforeEnter: (to, from, next) => {
                if(from.path == "/" && from.name !="Home")
                {
                    localStorage.setItem("nextURL",to.path);
                }
                guard(to, from, next);
            }
        },
        {
            path: "/Portal/Help",
            name:"Help",
            component: () => import("@/components/portal/Help"),
            // beforeEnter: (to, from, next) => {
            //     if(from.path == "/" && from.name !="Home")
            //     {
            //         localStorage.setItem("nextURL",to.path);
            //     }
            //     guard(to, from, next);
            // }
        },
        {
            path: "/Resources/Demo",
            name: "Demo",
            component: () => import("@/components/portal/Demo")
        },
        {
            path: "/Resources/Demo",
            name: "Demo",
            component: () => import("@/components/portal/Demo")
        },
        {
            path: "/Portal/Frames",
            name:"FramesCenter",
            component: FramesCenter,
            beforeEnter: (to, from, next) => {
                if(from.path == "/" && from.name !="Home")
                {
                    guard(to, from, next);
                    localStorage.setItem("nextURL",to.path);
                }
                else
                {
                    var retFrame = localStorage.getItem("frameAndLensOrderIsAllowed");
                    if (retFrame == "true")
                    {
                        guard(to, from, next);
                    }
                    else
                        window.location.href="/Portal/Home/";
                }
            }
        },
        {
            path: "/Portal/FrameOrderSuccess",
            name:"FramesOrderSuccess",
            component: FrameOrderSuccess,
            beforeEnter: (to, from, next) => {
                guard(to, from, next);
            }
        },

    ],
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },

    GetOrderStatus(orderId){
        var _this = this;

    }
});



// WEBPACK FOOTER //
// ./src/router/index.js